import { Translations, translations } from '../translations/translations';

export const pickData = ({ data }: any) => data;
export const validateData = (data: any) => {
    if (data.error) {
        throw new Error(data.error);
    }

    return data;
};

export const extendApiTranslationsWithLocalTranslations = (result: Translations) => ({
    EN: { ...translations.EN, ...result.EN },
    FR: { ...translations.FR, ...result.FR },
});
